<template>
  <v-btn
    color="primary"
    :elevation="0"
    dark
    rounded
    :height="46"
    :width="46"
    class="round-button"
    v-bind="attrs"
    v-on="on"
  >
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseRoundButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    on: { type: Object },
    attrs: { type: Object },
  },
};
</script>

<style lang="scss" scoped>
.round-button {
  min-width: 46px !important;
}
</style>
